module.exports = __webpack_public_path__ + "img/code_asi_2.2e82eaa0.png";